var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterATownCityOrPostcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17563",
    "data-name": "Group 17563",
    transform: "translate(-944 -598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location-pin",
    d: "M7.893,0A4.916,4.916,0,0,0,3,4.928c0,3.861,4.433,7.848,4.621,8.016a.409.409,0,0,0,.543,0c.189-.168,4.621-4.155,4.621-8.016A4.916,4.916,0,0,0,7.893,0Zm0,7.611a2.718,2.718,0,1,1,2.718-2.718A2.721,2.721,0,0,1,7.893,7.611Z",
    transform: "translate(946 601)",
    fill: "#c22127"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 20,
    height: 20,
    transform: "translate(944 598)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterATownCityOrPostcode);
export default __webpack_public_path__ + "static/media/enter_a_town_city_or_postcode.9aac13bc94d8145f62a294f55c83b770.svg";
export { ForwardRef as ReactComponent };